import client from '../client';

const trackEvent = (eventName, props) => {
  client.track(eventName, props);
};

export default trackEvent;
